import styled from 'styled-components';
import StyledText from '../shared/StyledText';
import { TABLET_SIZE } from '../../constants';
import { withI18next } from '../../lib/withI18next';

const Container = styled.div`
  @media (max-width: ${TABLET_SIZE}) {
    text-align: center;
    margin: 30px;
  }
`;

const Contact = ({ t }) => (
  <Container>
    <StyledText margin="0 0 5px 0" isBold>
      {t('COMPONENTS_FOOTER_CONTACT_TEXT')}
    </StyledText>
    <StyledText>info@damehru.cz</StyledText>
    <a href={t('COMPONENTS_FOOTER_CONTACT_LINK')}>
      <StyledText>www.inventi.cz</StyledText>
    </a>
  </Container>
);

export default withI18next()(Contact);



// WEBPACK FOOTER //
// components/Footer/Contact.js